import React, { Component } from 'react';
import { getImageChannel } from './../../../../constants/order'
import { convertDateFromUTC } from './../../../../services/dst';

class Row extends Component {
    render() {
        const { preview, keyRow, previewItem } = this.props
        return (
            <tr
                id='row-import-order'
                className={(keyRow % 2) !== 0 ? 'row-import-order-even' : null}
            >
                <td className="col-no">{preview.OrderNo}</td>
                <td className="col-channel">{getImageChannel(preview.ChannelName)}</td>
                <td className="col-orderid">{preview.ChannelOrderID}</td>
                <td className="col-date">{preview.OrderDT ? convertDateFromUTC(preview.OrderDT).format('MM/DD/YYYY HH:mm') : preview.OrderDT}</td>
                <td className="col-name">{preview.ConsigneeNameCH}</td>
                <td className="col-kana">{preview.ConsigneeKanaNameCH}</td>
                <td className="col-phone">{preview.ConsigneePhoneCH}</td>
                <td className="col-email">{preview.ConsigneeEmailCH}</td>
                <td className="col-postal">{preview.ConsigneePostalCodeCH}</td>
                <td className="col-add">{preview.ConsigneeAddress1CH}</td>
                <td className="col-add">{preview.ConsigneeAddress2CH}</td>
                <td className="col-add">{preview.ConsigneeAddress3CH}</td>
                <td className="col-add">{preview.ConsigneeAddress4CH}</td>
                <td className="col-add">{preview.ConsigneeCountryCH}</td>
                <td className="col-term">{preview.PaymentTermCH}</td>
                <td className="col-delive">{preview.DeliveryTimeCH}</td>
                <td className="col-currency">{preview.CurrencyCH}</td>
                <td className="col-advance">{preview.AdvanceNoticeCH}</td>
                <td className="col-package">1</td>
                <td className="col-gross"></td>
                <td className="col-volumn"></td>
                <td className="col-weight"></td>
                <td className="col-charge"></td>
                <td className="col-itemsku">{preview.SKU}</td>
                <td className="col-itemcode">{preview.ItemCode}</td>
                <td className="col-itemname">{preview.ItemName}</td>
                <td className="col-itemprice">{preview.UnitPrice}</td>
                <td className="col-itemqua">{preview.QuantityOrdered}</td>
                <td className="col-itemcountry">{preview.CountryOfOrigin}</td>
                <td className="col-itemchannel">{preview.ChannelOrderItemId}</td>
                <td className="col-collectamount">{preview.CollectAmount}</td>
                <td className="col-remark">{preview.Remark}</td>
                <td className="col-gstpaid">{preview.GSTPaid}</td>
                <td className="col-handlingcharge">{preview.HandlingCharge}</td>
            </tr>
        );
    }
}

export default Row;



// WEBPACK FOOTER //
// ./src/components/step-import-order/components/import-preview/Row.js